import type { IconColor } from '@alltrails/denali/components/Icon';
import type { IconComponent } from '@alltrails/denali/components/Icon';
import Caution from '@alltrails/denali/icons/Caution';
import Closure from '@alltrails/denali/icons/Closure';
import ErrorIcon from '@alltrails/denali/icons/Error';
import Info from '@alltrails/denali/icons/Info';
import { AlertType } from '@alltrails/types/Alert';

export const alertTypeIconColor: Record<AlertType, IconColor> = {
  [AlertType.CLOSURE]: '--color-text-error',
  [AlertType.DANGER]: '--color-text-error',
  [AlertType.WARNING]: '--color-text-caution',
  [AlertType.INFORMATION]: '--color-text-info'
};

export const alertTypeIcon: Record<AlertType, IconComponent> = {
  [AlertType.CLOSURE]: Closure,
  [AlertType.DANGER]: ErrorIcon,
  [AlertType.WARNING]: Caution,
  [AlertType.INFORMATION]: Info
};
